import { ModelApi } from '@/services/api/modelApi'
import {
  INotificationTrigger,
  IStatusTracking,
  TriggerStatus
} from '@/modules/notification-center/event-trigger/types/triggerTypes'

import { Id } from '@/shared/types/builtInTypes'
import axios from 'axios'
import { ApiListResponse } from '@/shared/types/apiListResponse'

export class NotificationTriggerEndpoints extends ModelApi<INotificationTrigger> {
  constructor() {
    super('trigger', 'notification')
  }

  // Change status of a trigger
  async changeTriggerStatus(
    triggerId: Id,
    status: TriggerStatus,
    notes?: string
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const url = `${this.getUrl()}${triggerId}/change_trigger_status/`
      axios
        .post(url, { status, notes })
        .then(response => {
          this.responseNotify('notifications.statusUpdatedSuccessfully')
          resolve(response.data)
        })
        .catch(error => {
          this.responseNotify(error.response.data, 'error')
          reject(error.response.data)
        })
    })
  }

  statusTrackingDatatable(
    params = {},
    triggerId: Id
  ): Promise<ApiListResponse<IStatusTracking>> {
    return new Promise((resolve, reject) => {
      const url = `${this.getUrl()}${triggerId}/status_tracking/`
      axios
        .get(url, {
          params: this.transformOptions(params)
        })
        .then(response => {
          this.dismissErrorNotification()
          resolve(response.data)
        })
        .catch(error => {
          this.responseNotify(error.response.data, 'error')
          reject(error.response.data)
        })
    })
  }
}
